import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ImageInput, ImagePreview } from "utils/imagePreviewURLConverter";
import imgUploadToCloudFun from "components/modals/imgUploadAndGetUrl";
import { CommonSelect, Input, TextArea } from "common/InputForm";
import { v4 as uuid } from "uuid";

import "../product-management.scss";
import {
  addNewProductApi,
  editSelectedProductApi,
  getMasterBrandData,
  getMasterCategoryData,
  getMasterProductType,
  getMasterSubCategoryData,
  getMasterUnitValue,
  selectedProductDetailApi,
} from "services/product-management";
import multiImgUploadToCloudFun from "components/modals/multiImageToCloud";
import JoditEditor from "jodit-react";
import {
  multiSubSubCategoryListApi,
  subCategoryListApi,
} from "services/subCategory";
import DeleteImage from "./DeleteImage";
import { MdOutlineCancel } from "react-icons/md";
import { IoChevronBack } from "react-icons/io5";
import { toastMessage } from "utils/toastMessage";

const EditSelectedProduct = () => {
  const blank = () => ({
    _id: uuid(),
    mrp: "",
    unit: "",
    unitValue: "",
    quantity: "",
    stockValue: "",
    originalStock: "", // 👈 add this

    highStockValue: "",
    isOutOfStock: false,

    extraStockValue: "",
    outOfStockValue: "",
  });
  const [variants, setVariants] = useState([blank()]);
  const editor = useRef(null);
  const { productId } = useParams();
  const [saltComposition, setSaltComposition] = useState("");
  // console.log('variants', variants)
  const navigate = useNavigate();

  const [error, setError] = useState({});

  // -----cloud img
  //   const [imgInputState, setImageInputState] = useState("");
  // 👉 imgInputState removed — payload is now derived directly from
  // imgPreviewState (each File carries its own __payloadPath), so we no
  // longer need a separate parallel array that could go out of sync.

  // -------image preview related state
  const [imgPreviewState, seImgPreviewState] = useState([]);

  // 👉 existingImageCount kept only for reference during initial load;
  // removal logic no longer depends on it (uses `instanceof File` instead).
  const [existingImageCount, setExistingImageCount] = useState(0);

  // console.log('imgPreviewState', imgPreviewState)
  // ---------------------apply coupon input Checkbox

  const [discountApply, setDiscountApply] = useState(false);
  const [couponNumberState, setCouponNumberState] = useState(0);
  // console.log('couponNumberState', couponNumberState)
  //   -------Right side part

  const [productName, setProductName] = useState("");

  // 👉 NEW: helper to safely display a filename for both File objects and
  // string URLs (existing cloud images)
  // 👉 NEW: backend expects `image` to be a plain array of path/url strings,
  // e.g. ["sindhi/images/169999-abc.png"], NOT an array of objects.
  // multiImgUploadToCloudFun's response (data?.data) returns objects
  // (e.g. { path/url/location/key/... }), so we normalize everything
  // to a plain string before sending. Adjust the key names below if your
  // upload API response uses a different field name.
  // 👉 NEW: backend expects a consistent relative path format like
  // "sindhi/images/xyz.png" — but existing (already-saved) images can come
  // back as a FULL S3 URL (e.g.
  // "https://sindhi-bucket.s3.ap-south-1.amazonaws.com/sindhi/images/xyz.png"),
  // while freshly uploaded images already come back as just the relative
  // path. This strips the "https://<bucket-domain>/" part (if present) so
  // both existing and new images end up in the SAME format before being
  // sent in the payload.
  const stripS3DomainFromUrl = (pathOrUrl) => {
    if (!pathOrUrl || typeof pathOrUrl !== "string") return pathOrUrl;
    // matches "http(s)://something.amazonaws.com/rest/of/path.png"
    // and returns just "rest/of/path.png"
    const match = pathOrUrl.match(/^https?:\/\/[^/]+\/(.+)$/i);
    return match ? match[1] : pathOrUrl;
  };

  const getImagePath = (img) => {
    if (!img) return "";
    if (typeof img === "string") return stripS3DomainFromUrl(img);
    if (img instanceof File) {
      // 👉 NEW: the actual uploaded path was attached directly onto this
      // File object at upload time (see imgUploadFunction). This guarantees
      // the payload value always travels WITH the exact object being shown
      // in preview / removed — no separate array, no index math, no desync.
      return img.__payloadPath ? stripS3DomainFromUrl(img.__payloadPath) : "";
    }
    const rawPath =
      img?.path ||
      img?.url ||
      img?.location ||
      img?.Location ||
      img?.key ||
      img?.Key ||
      img?.filename ||
      img?.image ||
      "";
    return stripS3DomainFromUrl(rawPath);
  };

  // 👉 NEW: stable, content-based key for each preview item.
  // Using array index as key is unsafe here — when the list is mutated
  // (new upload added, or an image removed), React can reassign the
  // same "position key" to a different item, causing it to remount the
  // wrong <ImagePreview>. Since ImagePreview creates a blob URL
  // (URL.createObjectURL) for File objects and revokes it on unmount,
  // this mismatch was revoking the blob URL of an image that was still
  // supposed to be shown — resulting in a broken image / alt="preview".
  const getPreviewKey = (img, ind) => {
    if (img instanceof File) {
      return `file-${img.name}-${img.size}-${img.lastModified}`;
    }
    if (typeof img === "string") return img;
    return img?.url || img?.path || img?._id || `img-${ind}`;
  };

  const getImageName = (img) => {
    if (!img) return "image";
    if (img instanceof File) return img.name;
    if (typeof img === "string") {
      try {
        return decodeURIComponent(img.split("/").pop().split("?")[0]);
      } catch {
        return img;
      }
    }
    // in case backend returns an object like { url, name }
    if (img?.name) return img.name;
    if (img?.url) {
      try {
        return decodeURIComponent(img.url.split("/").pop().split("?")[0]);
      } catch {
        return img.url;
      }
    }
    return "image";
  };

  const imgUploadFunction = async (e) => {
    try {
      const files = Array.from(e?.target?.files || []);
      const data = await multiImgUploadToCloudFun(e?.target?.files);
      // console.log("1st data?.data[0]:-------->", data?.data[0]);
      if (data?.status === 200) {
        //   console.log("2nd-------data?.data[0]:-------->", data?.data[0]);
        const uploadedList = data?.data || [];

        // 👉 FIX: instead of keeping a separate `imgInputState` array that
        // has to stay perfectly index-aligned with the preview array
        // (which was the root cause of removed images still showing up in
        // the payload), we attach each file's uploaded payload path
        // DIRECTLY onto the same File object that's used for preview.
        // Now preview + payload always refer to the exact same object —
        // remove the object from imgPreviewState, and it's gone from the
        // payload too, guaranteed.
        const filesWithPayload = files.map((file, idx) => {
          file.__payloadPath = getImagePath(uploadedList[idx]);
          return file;
        });

        // 👉 append new files AFTER existing preview images so
        // existing images always show first, then new ones.
        seImgPreviewState((prev) => [...prev, ...filesWithPayload]);
      }
    } catch (error) {
      console.log("error while uploading and getting data", error);
    }

    // if (!e?.target?.files[0]?.type.includes("image/")) {
    //   setError((stateProp) => ({
    //     ...stateProp,
    //     imgErrorOccur: "Please Choose Image file not others",
    //   }));
    // } else {
    //   try {
    //     const data = await imgUploadToCloudFun(e?.target?.files);
    //     // console.log("1st data?.data[0]:-------->", data?.data[0]);
    //     if (data?.status === 200) {
    //       //   console.log("2nd-------data?.data[0]:-------->", data?.data[0]);
    //       //   setImageInputState(data?.data[0]);
    //       setImageInputState(data?.data);

    //       seImgPreviewState(e?.target?.files[0]);
    //     }
    //   } catch (error) {
    //     console.log("error while uploading and getting data", error);
    //   }
    // }
  };

  // 👉 NEW: unified remove handler for the cross (❌) icon in preview list.
  // Whether an item is "existing" (server-saved) or "new" (freshly
  // uploaded, not yet submitted) is now determined by its TYPE, not by a
  // fragile index comparison against existingImageCount.
  const handleRemovePreviewImage = (ind, imag) => {
    if (imag instanceof File) {
      // Freshly uploaded, not-yet-submitted image -> remove immediately,
      // no API call needed. Since payload is derived straight from
      // imgPreviewState, this guarantees it will NOT be sent on submit.
      seImgPreviewState((prev) => prev.filter((_, i) => i !== ind));
    } else {
      // Already-saved (server) image -> go through existing confirm/delete
      // flow (opens modal / calls delete API), same as before.
      handleDeleteImage(singleProductId, ind, imag);
    }
  };

  // -------------master api data Call

  const [masterBrandState, setMasterBrandState] = useState([]);
  const [masterProductTypeState, setMasterProductTypeState] = useState([]);
  const [masterSubCategoryState, setMasterSubCategoryState] = useState([]);
  const [masterCategoryState, setMasterCategoryState] = useState([]);

  const [subSubCategoryList, setSubSubCategoryList] = useState([]);
  const [subSubCategoryValue, setSubSubCategoryValue] = useState([]);

  // console.log('masterSubCategoryState---->', masterSubCategoryState)
  // -----------description state

  const [descriptionState, setDescriptionState] = useState("");

  // --------------------------data

  const [selectedBrandOptionByAdmin, setSelectedBrandOptionByAdmin] =
    useState("");
  const [
    selectedProductTypeOptionByAdmin,
    setSelectedProductTypeOptionByAdmin,
  ] = useState("");

  // const [selectedCategoryOptionByAdmin, setSelectedCategoryOptionByAdmin] =
  //   useState("");
  const [selectedCategoryOptionByAdmin, setSelectedCategoryOptionByAdmin] =
    useState([]);
  const [multiSelectOptions, setMultiSelectOptions] = useState([]);

  const [masterUnitState, setMasterUnitState] = useState([]);
  // console.log('selectedCategoryOptionByAdmin', selectedCategoryOptionByAdmin)
  //   ----------------checkbox relATED
  const [hotDealApply, setHotDealApply] = useState(false);
  const [notForOnlineSale, setNotForOnlineSale] = useState(false);
  const [awardCoins, setAwardCoins] = useState(false);
  const [billOnlyInStrip, setBillOnlyInStrip] = useState(false);
  const [mrpValue, setMrpValue] = useState(0);
  const [checkData, setCheckData] = useState({
    prescriptionRequired: false,
    eligibleForCoupon: false,
    status: "", // or "ACTIVE"
    isShindhiRecommended: false,
  });

  const [singleProductId, setSingleProductId] = useState("");
  // console.log('checkData', checkData)
  const [deleteImage, setDeleteImage] = useState({ modal: false });
  // ---------handle-image-delete---------
  const handleDeleteImage = (data, index, img) => {
    setDeleteImage({ data, index, img, modal: true });
  };

  const callMasterCategoryApi = async () => {
    const query = { type: "CATEGORY" };
    try {
      const {
        data: { status, code, data },
      } = await getMasterCategoryData(query);

      if (status || code === 200) {
        setMasterCategoryState(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const callMasterSubCategoryApi = async () => {
    if (selectedCategoryOptionByAdmin.length > 0) {
      const categoryArr = selectedCategoryOptionByAdmin.map(
        (item) => item?.value,
      );
      const query = {
        limit: 1000,
        category: categoryArr,
      };
      try {
        const {
          data: { status, code, data },
          // } = await getMasterSubCategoryData(query);
        } = await subCategoryListApi(query);

        if (status || code === 200) {
          setMasterSubCategoryState(data?.data);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const callMasterBrandApi = async () => {
    try {
      const {
        data: { status, code, data },
      } = await getMasterBrandData();

      if (status || code === 200) {
        setMasterBrandState(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const callMasterProductType = async () => {
    try {
      const {
        data: { status, code, data },
      } = await getMasterProductType();
      if (status || code === 200) {
        setMasterProductTypeState(data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    const fetchSubSubCategoryList = async () => {
      if (multiSelectOptions.length > 0) {
        // Collect all selected subcategory IDs
        const subCategoryArr = multiSelectOptions.map((item) => item?.value);

        const query = {
          limit: 100,
          subcategories: subCategoryArr,
        };

        try {
          const {
            data: { status, code, data },
          } = await multiSubSubCategoryListApi(query);

          if (status || code === 200) {
            setSubSubCategoryList(data?.data || []);
          }
        } catch (error) {
          console.log(error);
        }
      }
    };
    fetchSubSubCategoryList();
  }, [multiSelectOptions]);
  const callMasterUnitValueApi = async () => {
    try {
      const {
        data: { status, code, data },
      } = await getMasterUnitValue();

      if (status || code === 200) {
        setMasterUnitState(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    callMasterCategoryApi();
    // callMasterSubCategoryApi();
    callMasterBrandApi();
    callMasterProductType();
    callMasterUnitValueApi();
  }, []);
  useEffect(() => {
    callMasterSubCategoryApi();
  }, [selectedCategoryOptionByAdmin]);

  // Input Validation
  const validation = () => {
    let status = true;
    let errorObject = {};

    // if (!imgInputState.length) {
    //   errorObject["imgEmptyErrorMsg"] = "Image is not Set";
    //   status = false;
    // }

    if (!productName.length) {
      errorObject["productName"] = "Product Name is Required";
      status = false;
    }

    // if(!selectedBrandOptionByAdmin.length)
    // {
    //   errorObject["selectedBrandOptionByAdmin"] = "Brand is Required";
    //   status = false;
    // }
    // if (!saltComposition.length) {
    //   errorObject["saltComposition"] = "Salt composition Name is Required";
    //   status = false;
    // }
    if (!selectedProductTypeOptionByAdmin.length) {
      errorObject["selectedProductTypeOptionByAdmin"] =
        "Product Type is Required";
      status = false;
    }

    if (!selectedCategoryOptionByAdmin.length) {
      errorObject["selectedCategoryOptionByAdmin"] = "Category is Required";
      status = false;
    }

    if (!multiSelectOptions.length) {
      errorObject["multiSelectOptions"] = "Sub-Category is Required";
      status = false;
    }

    // if (!descriptionState.length) {
    //   errorObject["descriptionState"] = "Description is Required";
    //   status = false;
    // }

    if (!variants.length) {
      errorObject["variantError"] = "At least one variant is required";
      status = false;
    } else {
      variants.forEach((v, idx) => {
        const missingFields = [];
        if (!v.mrp?.toString().trim()) missingFields.push("MRP");
        if (!v.unit?.toString().trim()) missingFields.push("Unit");
        if (!v.unitValue?.toString().trim()) missingFields.push("Unit Value");
        // if (!v.quantity?.toString().trim()) missingFields.push("Quantity");
        if (!v.stockValue?.toString().trim()) missingFields.push("stockValue");
        if (!v.outOfStockValue?.toString().trim())
          missingFields.push("Out Of Stock Value");
        if (missingFields.length) {
          errorObject[`variant_${idx}`] = `Variant ${
            idx + 1
          }: ${missingFields.join(", ")} required`;
          status = false;
        }
      });
    }

    setError(errorObject);

    return status;
  };

  const doSubmit = async () => {
    if (validation()) {
      const { productIds, ...rest } = checkData;
      const dataToSend = {
        ...rest,
        name: productName,
        isDiscountAvailable: discountApply,
        discountPercentage: couponNumberState,
        // category: selectedCategoryOptionByAdmin,
        category: selectedCategoryOptionByAdmin.map((mapPro) => mapPro.value),
        subcategory: multiSelectOptions.map((mapPro) => mapPro.value),
        subsubcategory: subSubCategoryValue.map((mapPro) => mapPro.value),
        brand: selectedBrandOptionByAdmin,
        saltComposition,
        // image: imgInputState,
        description: descriptionState,
        productType: selectedProductTypeOptionByAdmin,
        variant: variants.map((mapProp) => {
          const extra = Number(mapProp.extraStockValue || 0);
          const stock = Number(mapProp.stockValue || 0);
          return {
            ...((mapProp._id && { _id: mapProp._id }) || ""),
            mrp: mapProp.mrp,
            isOutOfStock: mapProp.isOutOfStock,
            productType: selectedProductTypeOptionByAdmin,
            unit: mapProp.unit,
            unitValue: mapProp.unitValue,
            quantity: mapProp.quantity,
            // stockValue: mapProp.stockValue,
            // stockValue: Number(mapProp.stockValue) -Number(mapProp.extraStockValue),
            // stockValue: Number(mapProp.stockValue),
            stockValue: extra < 0 ? stock : stock - extra,

            highStockValue: mapProp.highStockValue,
            extraStockValue: mapProp.extraStockValue,
            outOfStockValue: mapProp.outOfStockValue,
          };
        }),

        isHotDeal: hotDealApply,
        forOnlineSale: notForOnlineSale,
        awardCoin: awardCoins,
        billOnlyInStrip: billOnlyInStrip,
      };

      // 👉 FIX: payload is now built DIRECTLY from imgPreviewState — the
      // exact same array that's rendered on screen. Whatever the user sees
      // in the preview list is exactly what gets sent; anything removed via
      // the cross (❌) icon is gone from this array and therefore can never
      // reappear in the payload. No more separate array, no index math.
      const finalImages = imgPreviewState
        .map((img) => getImagePath(img))
        .filter(Boolean);

      if (finalImages.length > 0) {
        dataToSend.image = finalImages;
      }

      console.log(dataToSend.stockValue, "HELLOOW*********************");

      try {
        const {
          data: { status, code },
        } = await editSelectedProductApi({ id: productId, data: dataToSend });
        if (status || code === 200) {
                    toastMessage("Product updated successfully", "success", "addPromoCode");
          
          // navigate("/product-management");
          navigate(-1);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const fetchProductDetail = async () => {
    try {
      const {
        data: { status, code, data },
      } = await selectedProductDetailApi(productId);
      // console.log('data', data)
      if (status || code === 200) {
        // console.log('data main fetch', data)
        setSingleProductId(data?._id);
        setProductName(data?.name);
        setSelectedBrandOptionByAdmin(data?.brand);
        setSelectedProductTypeOptionByAdmin(data?.productType);
        // setSelectedCategoryOptionByAdmin(data?.category);
        setSaltComposition(data?.saltComposition);
        setSelectedCategoryOptionByAdmin(
          data?.category?.map((propId) => {
            return { value: propId._id, label: propId.name };
          }),
        );
        setMultiSelectOptions(
          data?.subcategory.map((propId) => {
            return { value: propId._id, label: propId.name };
          }),
        );
        setSubSubCategoryValue(
          data?.subsubcategory?.map((propId) => {
            return { value: propId._id, label: propId.name };
          }),
        );
        setCheckData({
          prescriptionRequired: data?.prescriptionRequired,
          eligibleForCoupon: data?.eligibleForCoupon,
          productIds: data?.productId,
          status: data?.status,
          isShindhiRecommended: data?.isShindhiRecommended,
        });
        // {masterSubCategoryState.map((item) => ({
        //     value: item._id,
        //     label: item.name,
        //   }))}

        setDescriptionState(data?.description);
        setDiscountApply(data?.isDiscountAvailable);
        setCouponNumberState(data?.discountPercentage);
        setHotDealApply(data?.isHotDeal);
        setNotForOnlineSale(data?.forOnlineSale);
        setAwardCoins(data?.awardCoin);
        setBillOnlyInStrip(data?.billOnlyInStrip);

        // 👉 preview state = existing (server-saved) images on (re)load.
        // existingImageCount kept for reference only; removal logic uses
        // `instanceof File` to tell existing vs new apart now.
        const existingImages = data?.image || [];
        seImgPreviewState(existingImages);
        setExistingImageCount(existingImages.length);

        // setVariants(data?.variant);

        setVariants(
          data?.variant?.map((v) => ({
            ...v,
            originalStock: v.stockValue, // 👈 YAHI ADD KARNA HAI
          })),
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchProductDetail();
  }, []);

  return (
    <div className="add_products">
      {/* <Link to={-1} style={{ color: "#800080" }}>
        Product-Management
      </Link>
      /editNewProduct  */}
      <div className="link-header-holder">
        <p>
          <Link to={-1}>
            <IoChevronBack />
            Back
          </Link>
          <span>Product-Management</span>
          &nbsp;
          <span>/ Edit New Product </span>
        </p>
      </div>
      <div className="card">
        {checkData?.productIds && (
          <p>
            Product Id: <b>{checkData?.productIds}</b>
          </p>
        )}
        {/* ------------------------------left side part starts */}
        <div className="form_field_wrap">
          <div className="form_field">
            <Input
              label="Product Name"
              value={productName}
              onChange={(e) => {
                setProductName(e.target.value);
              }}
             
            />

            {error["productName"] && (
              <div>
                <p style={{ color: "red", marginTop: 4 }}>
                  {error["productName"]}
                </p>
              </div>
            )}
          </div>

          {/* {masterBrandState.length > 0 && (
            <div className="form_field">
              <Select
                label="Select Brand"
                value={selectedBrandOptionByAdmin}
                onChange={(e) => {
                  setSelectedBrandOptionByAdmin(e.target.value);
                }}
              >
                <option value="">Select Brand</option>
                {masterBrandState.map((brandMapProp, ind) => (
                  <option value={brandMapProp._id} key={ind}>
                    {brandMapProp.name}
                  </option>
                ))}
              </Select>
            </div>
          )} */}

          <div className="form_field">
            <CommonSelect
              label="Select Brand"
              value={
                masterBrandState
                  .map((item) => ({ value: item._id, label: item.name }))
                  .find((item) => item.value === selectedBrandOptionByAdmin) ||
                null
              }
              onChange={(selectedOption) => {
                setSelectedBrandOptionByAdmin(selectedOption?.value || "");
              }}
              options={masterBrandState.map((item) => ({
                value: item._id,
                label: item.name,
              }))}
              isSearchable={true}
            />
          </div>
          {/* --------------------master product type select */}

          {masterProductTypeState.length > 0 && (
            <div className="form_field">
              <CommonSelect
                label="Product Type"
                value={
                  masterProductTypeState
                    .map((item) => ({ value: item._id, label: item.name }))
                    .find(
                      (item) => item.value === selectedProductTypeOptionByAdmin,
                    ) || null
                }
                onChange={(selectedOption) => {
                  setSelectedProductTypeOptionByAdmin(
                    selectedOption?.value || "",
                  );
                }}
                options={masterProductTypeState.map((item) => ({
                  value: item._id,
                  label: item.name,
                }))}
                isSearchable={true}
                placeholder="Select Product Type"
              />

              {error["selectedProductTypeOptionByAdmin"] && (
                <div>
                  <p style={{ color: "red", marginTop: 4 }}>
                    {error["selectedProductTypeOptionByAdmin"]}
                  </p>
                </div>
              )}
            </div>
          )}

          {/* -------------- masterCategoryState */}
          {/* {masterCategoryState.length > 0 && (
            <div className="form_field">
              <Select
                label="Category Name"
                value={selectedCategoryOptionByAdmin}
                onChange={(e) => {
                  setSelectedCategoryOptionByAdmin(e.target.value);
                }}
              >
                <option value="">Select Category</option>
                {masterCategoryState.map((categoryMapProp, ind) => (
                  <option value={categoryMapProp._id} key={ind + 2}>
                    {categoryMapProp.name}
                  </option>
                ))}
              </Select>

              {error["selectedCategoryOptionByAdmin"] && (
                <div>
                  <p style={{ color: "red", marginTop: 4 }}>
                    {error["selectedCategoryOptionByAdmin"]}
                  </p>
                </div>
              )}
            </div>
          )} */}
          <div className="form_field">
            <CommonSelect
              value={selectedCategoryOptionByAdmin || []}
              label="Category Name"
              name="SubCategoryName"
              isMulti={true}
              onChange={(commonSelectData) => {
                setSelectedCategoryOptionByAdmin(commonSelectData);
                setMultiSelectOptions([]);
                setSubSubCategoryValue([]);
              }}
              // options={[
              //   { value: "apple", label: "Apple" },
              //   { value: "banana", label: "Banana" },
              //   { value: "mango", label: "Mango" },
              //   { value: "grape", label: "Grape" },
              // ]}
              options={masterCategoryState.map((item) => ({
                value: item._id,
                label: item.name,
              }))}
              isSearchable={true}
            />

            {error["selectedCategoryOptionByAdmin"] && (
              <div>
                <p style={{ color: "red", marginTop: 4 }}>
                  {error["selectedCategoryOptionByAdmin"]}
                </p>
              </div>
            )}
          </div>
          {/* ---------------masterSubCategoryState  */}

          {/* {masterSubCategoryState.length > 0 && ( */}
          <div className="form_field">
            <CommonSelect
              value={multiSelectOptions || []}
              label="Sub-Category Name"
              name="SubCategoryName"
              isMulti={true}
              onChange={(commonSelectData) => {
                setMultiSelectOptions(commonSelectData);
                setSubSubCategoryValue([]);
              }}
              // options={[
              //   { value: "apple", label: "Apple" },
              //   { value: "banana", label: "Banana" },
              //   { value: "mango", label: "Mango" },
              //   { value: "grape", label: "Grape" },
              // ]}
              options={masterSubCategoryState?.map((item) => ({
                value: item._id,
                label: item.name,
              }))}
              isSearchable={true}
            />

            {error["multiSelectOptions"] && (
              <div>
                <p style={{ color: "red", marginTop: 4 }}>
                  {error["multiSelectOptions"]}
                </p>
              </div>
            )}
          </div>
          <div className="form_field">
            <CommonSelect
              value={subSubCategoryValue || []}
              label="Filter Category Name"
              name="subsubcategory"
              isMulti={true}
              onChange={(commonSelectData) => {
                setSubSubCategoryValue(commonSelectData);
              }}
              options={(subSubCategoryList || [])?.map((item) => ({
                value: item._id,
                label: item.name,
              }))}
              isSearchable={true}
            />
          </div>
          <div className="form_field">
            <TextArea
              label="salt Composition"
              placeholder="salt Composition"
              name="saltComposition"
              value={saltComposition}
              onChange={(e) => {
                setSaltComposition(e.target.value);
              }}
              
            />

            {/* {error["saltComposition"] && (
              <div>
                <p className="error">{error["saltComposition"]}</p>
              </div>
            )} */}
          </div>
          {/* )} */}

          {/* --------------------Description ------------- */}

          <div className="form_field w-100">
            {/* <TextArea
              label="Description"
              value={descriptionState}
              onChange={(e) => {
                setDescriptionState(e.target.value);
              }}
              maxLength={200}
            /> */}
            <label htmlFor="">Description</label>
            <JoditEditor
              ref={editor}
              value={descriptionState}
              tabIndex={1}
              onBlur={(newContent) => setDescriptionState(newContent)}
              config={{
                readonly: false,
                height: 200,
                placeholder: "Edit content here...",
              }}
            />

            {error["descriptionState"] && (
              <div>
                <p style={{ color: "red", marginTop: 4 }}>
                  {error["descriptionState"]}
                </p>
              </div>
            )}
          </div>

          <div className="form_field_wrap">
            <DynamicInputField
              variants={variants}
              setVariants={setVariants}
              blank={blank}
              masterUnitState={masterUnitState}
              error={error}
            />
          </div>

          {/* -----------stock value */}
        </div>

        {/* ---------------------------------right side */}
        <div className="form_field_wrap">
          <div className="form_field">
            <label className="label">Change Image</label>

            {/* 👉 NEW: custom file input UI — native input's "No file chosen"
                text can't be changed via JS, so we hide the native input and
                build our own "Choose files" button + selected-names display. */}
            <div
              className="custom-file-input-wrap"
              style={{ display: "flex", alignItems: "center", gap: 10 }}
            >
              <label
                htmlFor="productImageUploadInput"
                className="choose-file-btn"
                style={{
                  cursor: "pointer",
                  padding: "8px 16px",
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  background: "#f5f5f5",
                  whiteSpace: "nowrap",
                  fontSize: 14,
                }}
              >
                Choose files
              </label>
              <input
                id="productImageUploadInput"
                onChange={imgUploadFunction}
                type="file"
                accept="image/*"
                multiple
                style={{ display: "none" }}
              />
              <span
                className="chosen-file-names"
                style={{
                  fontSize: 13,
                  color: "#555",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                title={
                  imgPreviewState.length > 0
                    ? imgPreviewState.map((img) => getImageName(img)).join(", ")
                    : "No file chosen"
                }
              >
                {imgPreviewState.length > 0
                  ? imgPreviewState.map((img) => getImageName(img)).join(", ")
                  : "No file chosen"}
              </span>
            </div>

            {error["imgEmptyErrorMsg"] && (
              <span className="error">{error["imgEmptyErrorMsg"]}</span>
            )}
            {error["imgErrorOccur"] && (
              <p className="error">{error["imgErrorOccur"]}</p>
            )}

            {/* ------image preview Container div */}
            <div className="image_preview multi_preview">
              {imgPreviewState.length > 0 &&
                imgPreviewState.map((imag, ind) => {
                  const stableKey = getPreviewKey(imag, ind);
                  return (
                    // imag.file ? <ImagePreview file={imag?.file} key={ind} /> :
                    <div key={stableKey} className="item">
                      <MdOutlineCancel
                        onClick={() => handleRemovePreviewImage(ind, imag)}
                      />
                      <ImagePreview file={imag} key={stableKey} />
                    </div>
                  );
                })}
            </div>
            {/* ----end of img preview component */}
          </div>

          {/* ------------set coupon and checkbox  */}
          <div className="form_field">
            <label htmlFor="couponIdApply" className="label">
              <input
                id="couponIdApply"
                type="checkbox"
                onChange={(e) => {
                  setDiscountApply(e.target.checked);
                  if (!e.target.checked) {
                    setCouponNumberState(0); // Reset the state itself
                  }
                }}
                value={discountApply}
                checked={discountApply}
              />{" "}
              Apply Discount(%)
            </label>

            <Input
              type="text"
              name="couponNumber"
              value={couponNumberState}
              // onChange={(e) => {
              //   setCouponNumberState(e.target.value);
              // }}
              onChange={(e) => {
                const value = e.target.value;
                // Allow only numbers using regex
                if (/^\d*$/.test(value)) {
                  setCouponNumberState(value);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              disabled={!discountApply}
              maxLength={2}
            />

            {/* ------------set coupon and checkbox  */}
            <div className="select_list">
              <label htmlFor="markInHotDealIdApply">
                <input
                  id="markInHotDealIdApply"
                  type="checkbox"
                  onChange={(e) => {
                    setHotDealApply(e.target.checked);
                  }}
                  value={hotDealApply}
                  checked={hotDealApply}
                />{" "}
                Mark In Hot Deals
              </label>

              <label htmlFor="notForSaleId">
                <input
                  id="notForSaleId"
                  type="checkbox"
                  value={notForOnlineSale}
                  onChange={(e) => {
                    setNotForOnlineSale(e.target.checked);
                  }}
                  checked={notForOnlineSale}
                />{" "}
                Not For Online Sales
              </label>

              <label htmlFor="forAwardCoinId">
                <input
                  id="forAwardCoinId"
                  type="checkbox"
                  value={awardCoins}
                  onChange={(e) => {
                    setAwardCoins(e.target.checked);
                  }}
                  checked={awardCoins}
                />{" "}
                Award Coins
              </label>

              <label htmlFor="prescriptionRequired">
                <input
                  id="prescriptionRequired"
                  type="checkbox"
                  checked={checkData.prescriptionRequired}
                  onChange={(e) =>
                    setCheckData({
                      ...checkData,
                      prescriptionRequired: e.target.checked,
                    })
                  }
                />{" "}
                {"Prescription Required/OTC (Over the Counter)"}
              </label>

              <label htmlFor="eligibleForCoupon">
                <input
                  id="eligibleForCoupon"
                  type="checkbox"
                  checked={checkData.eligibleForCoupon}
                  onChange={(e) =>
                    setCheckData({
                      ...checkData,
                      eligibleForCoupon: e.target.checked,
                    })
                  }
                />{" "}
                Eligible for Coupon
              </label>

              <label htmlFor="InvisibleOption">
                <input
                  id="InvisibleOption"
                  type="checkbox"
                  checked={checkData.status === "INACTIVE"} // convert string to boolean
                  onChange={(e) =>
                    setCheckData({
                      ...checkData,
                      status: e.target.checked ? "INACTIVE" : "ACTIVE", // toggle string value
                      // status: e.target.checked ? "ACTIVE" : "INACTIVE", // toggle string value
                    })
                  }
                />{" "}
                Invisible Option
              </label>

              <label htmlFor="isShindhiRecommended">
                <input
                  id="isShindhiRecommended"
                  type="checkbox"
                  checked={checkData.isShindhiRecommended}
                  onChange={(e) =>
                    setCheckData({
                      ...checkData,
                      isShindhiRecommended: e.target.checked,
                    })
                  }
                />{" "}
                sindhi Recommended
              </label>
              <label htmlFor="billOnlyInStrip">
                <input
                  id="billOnlyInStrip"
                  type="checkbox"
                  value={billOnlyInStrip}
                  onChange={(e) => {
                    setBillOnlyInStrip(e.target.checked);
                  }}
                  checked={billOnlyInStrip}
                />{" "}
                Bill Only In Strip
              </label>
            </div>
          </div>

          {/* ----------------mark in hot deal */}
        </div>

        {/* --------add product  */}
        <div className="button_wrap">
          <button className="button" type="button" onClick={doSubmit}>
            Update Product
          </button>
        </div>
      </div>
      <DeleteImage
        show={deleteImage?.modal}
        close={() => setDeleteImage({ modal: false })}
        listing={fetchProductDetail}
        data={deleteImage}
        setState={seImgPreviewState}
      />
    </div>
  );
};

export default EditSelectedProduct;

const DynamicInputField = ({
  variants,
  setVariants,
  blank,
  masterUnitState,
  error,
}) => {
  const update1 = (id, key, val) => {
    setVariants((prev) =>
      prev.map((v) => {
        if (v._id !== id) return v;

        const updated = { ...v, [key]: val };

        // 👉 extra stock change
        if (key === "extraStockValue") {
          const original = Number(v.originalStock ?? v.stockValue ?? 0);
          const extra = Number(val ?? 0);

          updated.stockValue = original + extra;
        }

        return updated;
      }),
    );
  };

  const update = (id, key, val) => {
    setVariants((prev) =>
      prev.map((v) => {
        if (v._id !== id) return v;

        const updated = { ...v, [key]: val };

        if (key === "extraStockValue") {
          const original = Number(v.originalStock ?? v.stockValue ?? 0);
          const extra = Number(val ?? 0);

          // ❗ prevent subtracting more than current stock
          if (extra < -original) {
            updated.extraStockValue = -original;
            updated.stockValue = 0;
          } else {
            updated.stockValue = original + extra;
          }
        }

        return updated;
      }),
    );
  };

  const add = () => setVariants((cur) => [...cur, blank()]);
  const remove = (id) => {
    setVariants((cur) =>
      cur.length > 1 ? cur.filter((v) => v._id !== id) : cur,
    );
  };

  return (
    <div>
      {variants.map((v, i) => (
        <div className="append_list" key={v._id}>
          {error[`variant_${i}`] && (
            <p style={{ color: "red", marginBottom: 4 }}>
              {error[`variant_${i}`]}
            </p>
          )}

          <div className="form_field">
            {/* <Input
              type="text"
              label="MRP"
              placeholder="MRP"
              value={v.mrp}
              // onChange={(e) => update(v._id, "mrp", e.target.value)}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\s+/g, "");
                if (/^\d*\.?\d{0,2}$/.test(input)) {
                  update(v._id, "mrp", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key))
                  e.preventDefault();
              }}
            /> */}



            <Input
  type="text"
  label="MRP"
  placeholder="MRP"
  value={v.mrp}
  inputMode="decimal"
  maxLength={12}
  onChange={(e) => {
    let input = e.target.value.replace(/\s+/g, "");

    // Allow numbers with up to 2 decimal places
    if (/^\d*\.?\d{0,2}$/.test(input)) {
      update(v._id, "mrp", input);
    }
  }}
  onKeyDown={(e) => {
    // Prevent scientific notation and negative values
    if (["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }

    // Allow only one decimal point
    if (e.key === "." && e.currentTarget.value.includes(".")) {
      e.preventDefault();
    }
  }}
/>
          </div>
          <div className="form_field">
            <CommonSelect
              value={
                masterUnitState
                  .map((unit) => ({ value: unit.name, label: unit.name }))
                  .find((item) => item.value === v.unit) || null
              }
              label="Product Pack Form"
              onChange={(selectedOption) => {
                update(v._id, "unit", selectedOption?.value || "");
              }}
              options={masterUnitState.map((unit) => ({
                value: unit.name,
                label: unit.name,
              }))}
              isSearchable={true}
              placeholder="Product Pack Form"
            />
          </div>
          <div className="form_field">
            <Input
              type="text"
              label="Per Product Size"
              placeholder="Per Product Size (supports decimals like 2.5 ml, 0.5 gm)"
              value={v.unitValue || ""}
              // onChange={(e) => update(v._id, "unitValue", e.target.value)}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\s+/g, "");
                if (/^\d*\.?\d{0,2}$/.test(input)) {
                  update(v._id, "unitValue", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key))
                  e.preventDefault();
              }}
            />
          </div>
          {false && (
            <div className="form_field">
              <Input
                type="text"
                label=" Minus Stock Quantity"
                placeholder="Minus Stock Quantity 
"
                value={v.quantity}
                // onChange={(e) => update(v._id, "quantity", e.target.value)}
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={9}
                onChange={(e) => {
                  let input = e.target.value;
                  input = input.replace(/\s+/g, "");
                  if (/^\d*\.?\d{0,2}$/.test(input)) {
                    update(v._id, "quantity", input);
                  }
                }}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-", "."].includes(e.key))
                    e.preventDefault();
                }}
              />
            </div>
          )}
          <div className="form_field">
            <Input
              type="text"
              label="Current Stock Quantity
"
              placeholder="Current Stock Quantity
"
              value={v.stockValue || ""}
              disabled
              // onChange={(e) => update(v._id, "stockValue", e.target.value)}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\s+/g, "");
                if (/^\d*\.?\d{0,2}$/.test(input)) {
                  update(v._id, "stockValue", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key))
                  e.preventDefault();
              }}
            />
          </div>

          <div className="form_field">
            <Input
              type="text"
              label="Add Stock Quantity/Minus Stock Quantity"
              placeholder="Add Stock Quantity"
              value={v.extraStockValue || ""}
              inputMode="numeric"
              name="extraStockValue"
              pattern="[0-9]*"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;

                // remove spaces
                input = input.replace(/\s+/g, "");

                // allow optional minus only at first position
                if (/^-?\d*$/.test(input)) {
                  update(v._id, "extraStockValue", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+"].includes(e.key)) {
                  e.preventDefault();
                }

                // allow minus only at first position
                if (e.key === "-" && e.target.selectionStart !== 0) {
                  e.preventDefault();
                }
              }}
            />
          </div>

          <div className="form_field">
            <Input
              type="text"
              label="Minimum Stock Quantity"
              placeholder="Minimum Stock Quantity"
              value={v.outOfStockValue || ""}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\s+/g, "");
                if (/^\d*\.?\d{0,2}$/.test(input)) {
                  update(v._id, "outOfStockValue", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key))
                  e.preventDefault();
              }}
            />
          </div>

          <div className="form_field">
            <Input
              type="text"
              label="Maximum Stock Quantity"
              placeholder="Maximum Stock Quantity
"
              value={v.highStockValue || ""}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\s+/g, "");
                if (/^\d*\.?\d{0,2}$/.test(input)) {
                  update(v._id, "highStockValue", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key))
                  e.preventDefault();
              }}
            />
          </div>

          <div className="form_field">
            <label className="label dummy">Dummy</label>
            <label>
              <input
                type="checkbox"
                checked={v.isOutOfStock}
                onChange={(e) =>
                  update(v._id, "isOutOfStock", e.target.checked)
                }
                className="me-1"
              />
              Mark Out of Stock
            </label>
          </div>
          {variants.length > 1 && (
            <div className="form_field">
              <button
                style={{ marginTop: "1rem" }}
                type="button"
                className="button"
                onClick={() => remove(v._id)}
              >
                Remove
              </button>
            </div>
          )}
        </div>
      ))}

      {/* <div className="button_wrap button_right">
        <button type="button" className="button" onClick={add}>
          + Add another variant
        </button>
      </div> */}  
    </div>
  );
};